var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1824_2414)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1824_2414)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0983 15.4873C30.6938 15.629 31.2626 15.8651 31.7838 16.1861L32.8791 15.6997L34.17 16.9905L33.6837 18.0855C34.0048 18.6068 34.2408 19.1758 34.3826 19.7715L35.5 20.2015V22.0271L34.3823 22.4573C34.2406 23.0529 34.0045 23.6216 33.6835 24.1429L34.17 25.2381L32.8791 26.529L31.7842 26.0427C31.2629 26.3638 30.6939 26.5999 30.0982 26.7416L29.6681 27.8591H27.8425L27.4123 26.7414C26.8168 26.5997 26.248 26.3636 25.7268 26.0426L24.6315 26.529L23.3406 25.2381L23.827 24.1432C23.5059 23.6219 23.2698 23.0529 23.128 22.4573L22.0106 22.0271V20.2016L23.1282 19.7714C23.2699 19.1759 23.506 18.607 23.827 18.0858L23.3406 16.9906L24.6315 15.6997L25.7268 16.1861C26.248 15.8651 26.8168 15.629 27.4123 15.4873L27.8426 14.3696H29.6681L30.0983 15.4873ZM16.1241 26.3451L17.7616 32.6732C17.8407 32.9791 17.6552 33.2943 17.3492 33.3734L16.131 33.6887C15.825 33.7678 15.5099 33.5823 15.4308 33.2763L13.7932 26.9482C13.714 26.6423 13.8996 26.3271 14.2056 26.248L15.4238 25.9328C15.7298 25.8536 16.0449 26.0391 16.1241 26.3451ZM15.1903 26.9777C14.9758 26.9525 14.7816 27.1061 14.7565 27.3205C14.7313 27.535 14.8848 27.7292 15.0993 27.7543C15.3137 27.7795 15.508 27.626 15.5331 27.4115C15.5582 27.197 15.4047 27.0028 15.1903 26.9777ZM18.9169 31.0489L23.5089 33.7001C24.0793 34.0295 24.6897 34.1118 25.3227 33.9229L33.2932 31.5433C33.6833 31.4269 33.874 30.874 33.7615 30.5015C33.51 29.6698 32.1038 29.9465 31.5187 30.1056L27.1603 31.2913C26.158 31.5638 25.5272 31.2834 24.7017 30.9117C24.6887 30.9059 24.6763 30.8994 24.6644 30.8923C23.8684 30.4924 23.1227 30.0096 22.3525 29.565C22.1737 29.4622 22.1121 29.234 22.2148 29.0552C22.3175 28.8764 22.5458 28.8148 22.7245 28.9175C23.0096 29.082 23.2486 29.2253 23.4842 29.3666C23.991 29.6704 24.4821 29.9647 24.9964 30.2234C25.3892 30.3822 25.7578 30.3469 25.9836 29.9558C25.9866 29.9506 25.9898 29.9455 25.993 29.9405C26.1811 29.5932 26.0345 29.1803 25.7208 28.9639C24.6411 28.4522 23.6475 27.7596 22.8663 27.2151C22.585 27.019 22.3306 26.8418 22.143 26.72C21.4922 26.2978 20.7301 26.4304 20.0252 26.6202L17.169 27.3893L18.1374 31.1315C18.3645 31.0707 18.7112 30.9175 18.9169 31.0489ZM18.1846 14.694C18.5663 14.7849 18.9309 14.9362 19.265 15.142L19.9672 14.8301L20.7947 15.6576L20.4829 16.3595C20.6888 16.6938 20.8401 17.0584 20.931 17.4403L21.6473 17.7161V18.8863L20.9308 19.1621C20.84 19.5439 20.6886 19.9084 20.4829 20.2426L20.7947 20.9447L19.9672 21.7722L19.2653 21.4605C18.9311 21.6663 18.5664 21.8177 18.1845 21.9085L17.9088 22.6249H16.7385L16.4627 21.9084C16.081 21.8175 15.7164 21.6662 15.3823 21.4605L14.6801 21.7723L13.8526 20.9448L14.1644 20.2429C13.9585 19.9087 13.8072 19.5439 13.7163 19.1621L13 18.8863V17.7161L13.7164 17.4403C13.8073 17.0585 13.9586 16.6939 14.1644 16.3597L13.8526 15.6577L14.6801 14.8301L15.3822 15.142C15.7163 14.9362 16.081 14.7849 16.4627 14.694L16.7385 13.9775H17.9088L18.1846 14.694ZM17.3236 16.2603C16.1964 16.2603 15.2827 17.1739 15.2827 18.3012C15.2827 19.4284 16.1964 20.3421 17.3236 20.3421C18.4509 20.3421 19.3645 19.4284 19.3645 18.3012C19.3646 17.1739 18.4509 16.2603 17.3236 16.2603ZM28.7553 17.6287C26.8302 17.6287 25.2697 19.1893 25.2697 21.1143C25.2697 23.0393 26.8302 24.5999 28.7553 24.5999C30.6803 24.5999 32.2409 23.0393 32.2409 21.1143C32.2409 19.1893 30.6804 17.6287 28.7553 17.6287Z",
    fill: "#8362E5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    stroke: "#E2E1F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1824_2414",
    x: -3,
    y: 5.97754,
    width: 54.5,
    height: 52.0449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.278431 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1824_2414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1824_2414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1824_2414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/services_icon.1909ebfbc082e168b5a143f2f0107bec.svg";
export { ForwardRef as ReactComponent };